import NovihomeAttributes from './NovihomeAttributes';

export default NovihomeAttributes;
